function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 382,
  height: 108,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F8FA",
  fillRule: "evenodd",
  d: "M284.935 4c5.241 0 9.491 3.699 9.491 8.26 0 4.563-4.25 8.262-9.491 8.262h-54.234c5.242 0 9.491 3.698 9.491 8.26 0 4.563-4.249 8.262-9.491 8.262h29.828c5.242 0 9.491 3.698 9.491 8.26 0 4.563-4.249 8.261-9.491 8.261h-13.794c-6.609 0-11.966 3.699-11.966 8.261q0 4.563 8.135 8.261c5.241 0 9.49 3.698 9.49 8.26 0 4.563-4.249 8.262-9.49 8.262H130.369c-5.242 0-9.491-3.699-9.491-8.261s4.249-8.261 9.491-8.261H77.491c-5.242 0-9.491-3.699-9.491-8.26 0-4.563 4.25-8.262 9.49-8.262h54.235c5.241 0 9.49-3.698 9.49-8.26 0-4.563-4.249-8.261-9.49-8.261H97.829c-5.242 0-9.491-3.699-9.491-8.261 0-4.563 4.249-8.261 9.49-8.261h54.234c-5.241 0-9.491-3.699-9.491-8.261S146.821 4 152.062 4zm0 33.044c5.241 0 9.491 3.698 9.491 8.26 0 4.563-4.25 8.261-9.491 8.261-5.242 0-9.491-3.698-9.491-8.26 0-4.563 4.249-8.261 9.491-8.261",
  clipRule: "evenodd",
  style: {
    fill: "#f7f8fa",
    fill: "color(display-p3 .9702 .9735 .98)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#476CFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.1,
  strokeWidth: 7.5,
  d: "M318.59 21.393h-10.03m17.789-16.666h-21.072zm8.588 0h-2.725zM115.745 104.001h-12.238m5.239-18.84h-25.71zm-34.427 0H68z",
  style: {
    stroke: "#476cff",
    stroke: "color(display-p3 .2784 .4235 1)",
    strokeOpacity: 0.1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#476CFF",
  fillOpacity: 0.24,
  d: "M183.5 28.5v-5h-5v5h-10A2.5 2.5 0 0 0 166 31v40a2.5 2.5 0 0 0 2.5 2.5h45A2.5 2.5 0 0 0 216 71V31a2.5 2.5 0 0 0-2.5-2.5h-10v-5h-5v5zM171 41h40v27.5h-40zm14.696 4.91L191 51.216l5.303-5.304 3.536 3.535-5.304 5.304 5.303 5.303-3.535 3.536L191 58.286l-5.304 5.303-3.535-3.536 5.303-5.303-5.303-5.304z",
  style: {
    fill: "#476cff",
    fill: "color(display-p3 .2784 .4235 1)",
    fillOpacity: 0.24
  }
}));
export { SvgCalendar as ReactComponent };
export default __webpack_public_path__ + "8a6b96e0c003173767b132874c36e31d.svg";